import { Colors, Services } from '@sigma-frontend-libs/commons'

import { icons } from '@/utils'

import cancel from '@/components/services/report-manager/commons/actions/cancel'
import filterBy from '@/components/services/report-manager/commons/filterBy/tags'
import timeline from '@/components/services/report-manager/commons/timeline/mini'
import toggle from '@/components/services/report-manager/recurrent/actions/toggle'
import { reportManagerRecurrentStatuses, service, serviceNameKebabCase, serviceNameViaPoint } from '@/components/services/report-manager/recurrent/utils'
import sticker from '@/components/sticker'
import actions from '@/components/templates/service/item/actions'
import date from '@/components/templates/service/item/date'
import owner from '@/components/templates/service/item/owner'

function renderName(h) {
  let value = this.getTranslate(`${Services['report-manager']}.types.${this.value.type}`)
  let label = this.getTranslate(`${Services['report-manager']}.labels.name`)

  if (this.viewport.size.width > 720) {
    value = this.value.name
  }
  if (this.viewport.size.width < 720) {
    label = this.value.name
  }

  return h(
    sticker,
    {
      props: {
        value,
        label,
        icon: reportManagerRecurrentStatuses[this.value.status]?.icon,
        color: reportManagerRecurrentStatuses[this.value.status]?.color,
        iconTooltip: this.getTranslate(`${Services['report-manager']}.statuses.${this.value.status}`),
        to: {
          name: `${serviceNameViaPoint}.single`,
          params: { id: this.value.id }
        }
      }
    }
  )
}
function renderType(h) {
  if (this.viewport.size.width > 720) {
    return h(
      sticker,
      {
        props: {
          value: this.getTranslate(`${Services['report-manager']}.types.${this.value.type}`),
          label: this.getTranslate(`${Services['report-manager']}.labels.type`),
          icon: icons.list,
          iconTooltip: this.value.type,
          color: Colors.grey
        }
      }
    )
  }
}
function renderFrequency(h) {
  if (this.viewport.size.width > 1350) {
    return h(
      sticker,
      {
        props: {
          value: this.frequency.value,
          label: this.frequency.label,
          icon: icons.repeat,
          color: Colors.grey,
          width: 145
        }
      }
    )
  }
}
function renderOwner(h) {
  if (this.viewport.size.width > 570) {
    return h(
      owner,
      {
        props: {
          value: this.value,
          width: 130
        }
      }
    )
  }
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-item__info`
    },
    [
      renderName.call(this, h),
      renderType.call(this, h),
      renderFrequency.call(this, h),
      renderOwner.call(this, h)
    ]
  )
}
function renderFilterBy(h) {
  if (this.viewport.size.width > 1800) {
    if (this.hasFilterBy) {
      return h(
        filterBy,
        {
          props: {
            value: this.value
          }
        }
      )
    }

    return h('div')
  }
}
function renderTimeline(h) {
  if (this.viewport.size.width > 1240) {
    return h(
      'div',
      {
        class: 'fjcfe hover-child'
      },
      [
        h(
          timeline,
          {
            props: {
              value: this.value,
              service
            }
          }
        )
      ]
    )
  }
}

function renderCancel(h) {
  return h(
    cancel,
    {
      props: {
        value: this.value,
        service
      }
    }
  )
}
function renderToggle(h) {
  return h(
    toggle,
    {
      props: {
        value: this.value
      }
    }
  )
}
function renderActions(h) {
  return h(
    actions,
    {
      props: {
        value: this.value,
        actions: [ 'remove' ],
        service
      }
    },
    [
      renderToggle.call(this, h),
      renderCancel.call(this, h)
    ]
  )
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

function renderDetails(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-item__details`
    },
    [
      renderFilterBy.call(this, h),
      renderTimeline.call(this, h),
      renderActions.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        'service-template-item hover-parent hover-parent--opacity': true,
        [`${serviceNameKebabCase}-item`]: true,
        [`${serviceNameKebabCase}-item--urgent`]: this.value.isUrgent
      }
    },
    [
      renderInfo.call(this, h),
      renderDetails.call(this, h)
    ]
  )
}
